import IdNameModel from '@/domain/models/id-name-model'

// @Deprecated
export interface Department {
  getAllOfUserCompany(): Promise<Department.Model[]>
}

export namespace Department {
  export type Model = IdNameModel
  export const Key = 'department'
}
